// extracted by mini-css-extract-plugin
export default {"grid":"IconsPage_grid__iU3OV","icon":"IconsPage_icon__9q1SK","title":"IconsPage_title__hU3PU"};